import { useGetNotificationTemplateAuthors } from "modules/communication";
import { Loading, ToggleSwitch } from "..";
import { Filter } from "../Filter";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: string[];
}

export const AuthorFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const { data: authors, isFetching: isLoading } = useGetNotificationTemplateAuthors();

    const renderFilter = () => {
        if (isLoading) return <Loading size="small" />;

        if (authors?.length) {
            return authors?.map(author => (
                <div key={author.name}>
                    <ToggleSwitch
                        value={author.uid}
                        checked={value.includes(author.uid)}
                        onChange={onChange}
                        htmlFor={author.name}
                        text={
                            <div className="filter__item__text">
                                {author.name?.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ));
        }

        return <p>Nema podataka</p>;
    };

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClick={onClick}
            onClear={onClear}
            text="AUTOR"
        >
            {renderFilter()}
        </Filter>
    );
};
